module.exports = __webpack_public_path__ + "img/bg-chat-tips-right.5f1c0430.png";